import * as React from 'react'

export const Button = () => {
  return <button type='button'>Boop</button>
}
